<template>
  <component :is="currentComponent" :key="etapeKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')" />
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import Etape1Inner from './Etape1Inner.vue';


defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const etapeKey = ref(0);

const currentComponent = ref(Etape1Inner);

defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

onMounted(() => {
  //console.log('Etape1 mounted');
  const onyx4 = document.getElementById('packopenv3-4blocs');
  onyx4.style.display = 'none';
  const best = document.getElementById('packopenv3-bestsell');
  best.style.display = 'none';
  nextTick(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 0);
  });
});


</script>
